import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TrackEventLink from '../../../components/track-event-link/TrackEventLink';
import { getOrganizationById } from '../../organizations-reducer';
import { getUserOrganizationStatus, MEMBER } from '../../authenticated-organization-helper';
import { fetchOrganization } from '../../organization-actions';
import { fetchSubscriptionForOrganization } from '../../../user/subscription/subscription-actions';
import Chevron from '../../../components/chevron/Chevron';
import AdminBar from '../../../admin-bar/AdminBar';
import { useUser } from '../../../user/useUser';
import styles from './organization-admin.module.less';

const OrganizationAdmin = ({ organizationId, children, editMode = false }) => {
    const dispatch = useDispatch();
    const user = useUser();
    const organization = useSelector((state) => getOrganizationById(state, organizationId));
    const userMemberStatus = getUserOrganizationStatus({ user, organizationId });

    useEffect(() => {
        if (organizationId) {
            dispatch(fetchOrganization(organizationId, true));

            if (user.id) {
                dispatch(fetchSubscriptionForOrganization(organizationId));
            }
        }
    }, [organizationId, user?.id]);

    if (userMemberStatus !== MEMBER || !organization) {
        return null;
    }

    return (
        <AdminBar className={editMode ? styles.editMode : ''}>
            <nav className={styles.actions}>
                {!editMode && (
                    <TrackEventLink
                        className={styles.adminLink}
                        to={`/org/${organizationId}/control`}
                        category="admin-organization"
                        action="control-panel-show"
                        properties={{ 'organization-id': organizationId, 'user-id': user.id }}
                    >
                        <Chevron direction="left" />
                        <span className={styles.adminLinkText}>Kontrollpanel</span>
                    </TrackEventLink>
                )}
                {children}
            </nav>
        </AdminBar>
    );
};

export default OrganizationAdmin;
